import { AxiosResponse } from 'axios'
import { API } from '../config'
import { CoatDto } from 'src/dto/coat.dto'

const BASE_URL = '/entity/Pelagem'

export class CoatService {
  public async getCoatList(): Promise<AxiosResponse<CoatDto[]>> {
    return await API.get(`${BASE_URL}`)
  }
}
